import { useEffect, useRef } from "react";

import type { API } from "simplydo/core/api";

type PageViewTarget = "challenge" | "idea" | "group";

/**
 * Logs one page view per id. Enable it once the page's data has loaded so the
 * view is sent with the same auth state as the request that loaded it.
 */
export const usePageView = (
  api: API,
  target: PageViewTarget,
  id: string | null | undefined,
  isEnabled = true,
) => {
  const loggedId = useRef<string | null>(null);

  useEffect(() => {
    if (!id) {
      loggedId.current = null;
      return;
    }
    if (!isEnabled || loggedId.current === id) return;
    loggedId.current = id;
    const logView = {
      challenge: api.challenges.logView,
      idea: api.ideas.logView,
      group: api.groups.logView,
    }[target];
    logView(
      id,
      () => {},
      () => {},
    );
  }, [api, target, id, isEnabled]);
};
